import { ApolloError } from '@apollo/client';
import { MutateResult } from '@vue/apollo-composable';
import { GraphQLFormattedError } from 'graphql';

import { useUserStore } from '@/shared/pinia/modules/user';

export const useCommunityDispatchUtils = () => {
  const userStore = useUserStore();

  const dispatchMutationWithTosRetry = async <TResult>(
    mutationExecutor: () => MutateResult<TResult>
  ) => {
    try {
      return await mutationExecutor();
    } catch (err: unknown) {
      if (isTosNotAcceptedError(err)) {
        const tosStatus =
          await userStore.openAndAwaitTermsOfServiceAgreementModal();
        if (tosStatus) {
          return await mutationExecutor();
        }
      }

      // rethrow unknown error
      throw err;
    }
  };

  return {
    dispatchMutationWithTosRetry
  };
};

export const isTosNotAcceptedError = (err: unknown): boolean =>
  err instanceof ApolloError && hasTosNotAcceptedError(err.graphQLErrors);

export const hasTosNotAcceptedError = (
  errors: readonly GraphQLFormattedError[]
) =>
  errors?.some(
    (e) =>
      e.extensions &&
      e.extensions.code === 'FORBIDDEN' &&
      e.extensions.reason === 'TERMS_NOT_ACCEPTED'
  ) ?? false;
